// @flow
import {create} from 'jss'
import preset from 'jss-preset-default'

export default create(preset())
